import React from "react";
import { Row, Col, Card } from "react-bootstrap";

const ProductLoader = ({ size = 4 }) => {
  const loader = () => {
    const rv = [];
    for (let i = 0; i < size; i++) {
      rv.push(
        <Col md={3} sm={6} xs={6} key={i}>
          <Card className="card-product mb-3">
            <div className="skeleton-image" />
            <div className="card-body px-2 py-2">
              <div className="skeleton-text title" />
              <div className="skeleton-text price" />
            </div>
          </Card>
        </Col>
      );
    }
    return rv;
  };

  return <Row>{loader()}</Row>;
};

export default ProductLoader;
